// Centralized role color mapping for consistency across UI surfaces

export const ROLE_COLORS: Record<string, string> = {
  'resio admin': '#9C27B0',
  'organization admin': '#2196F3',
  'billing admin': '#FF9800',
  'property admin': '#4CAF50',
};

/**
 * Get text color for a user role, defaults to neutral grey.
 */
export const getUserTypeColor = (userType: string): string => {
  const key = (userType || '').toLowerCase();
  return ROLE_COLORS[key] ?? '#757575';
};


